module.exports = __webpack_public_path__ + "static/media/on-the-laptop.9de7a810.svg";